import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=25891b19&lang=css"

const __exports__ = script;

export default __exports__